import { useEffect, useState } from 'react'
import store from '../../../store'
import { selectActiveChartId, selectChartFocused, selectChartReplayMode } from '../../../selectors/chart'
import { selectActiveLayoutId } from '../../../selectors/home'
import { WidgetTypes } from '../../../components/widgetDashboard/widgetDashboard.enums'

export type StockBarRuntime = {
    activeChartId: string
    disableChartOptions: boolean
    disableSettingsButton: boolean
    disableAlertButton: boolean
}

function computeRuntime(ivPlotTimeBucket: boolean): StockBarRuntime {
    const state = store.getState()
    const activeChartId = selectActiveChartId(state)
    const chartFocused = selectChartFocused(state)
    const replayModeState = selectChartReplayMode(state)
    const activeLayoutId = selectActiveLayoutId(state)
    const dashboard = state.widgetDashboardStore.layouts[activeLayoutId]
    const activeWidgetType = dashboard?.activeWidget
        ? dashboard.widgets[dashboard.activeWidget]?.widgetType
        : undefined

    const isRestrictedWidget =
        activeWidgetType != null &&
        [WidgetTypes.MULTI_STRIKE_CHART, WidgetTypes.OI_CHART, WidgetTypes.OPEN_INTEREST_CHART, WidgetTypes.OPTION_CHAIN].includes(activeWidgetType)

    const hasActiveWidget = activeWidgetType != null

    return {
        activeChartId,
        disableChartOptions: !!replayModeState || isRestrictedWidget || !chartFocused,
        disableSettingsButton: !!replayModeState || (!chartFocused && !hasActiveWidget),
        disableAlertButton: !!replayModeState || isRestrictedWidget || ivPlotTimeBucket || !activeChartId
    }
}

export function useStockBarRuntime(ivPlotTimeBucket: boolean): StockBarRuntime {
    const [runtime, setRuntime] = useState(() => computeRuntime(ivPlotTimeBucket))

    useEffect(() => {
        const sync = () => {
            const next = computeRuntime(ivPlotTimeBucket)
            setRuntime((prev) =>
                prev.activeChartId === next.activeChartId &&
                prev.disableChartOptions === next.disableChartOptions &&
                prev.disableSettingsButton === next.disableSettingsButton &&
                prev.disableAlertButton === next.disableAlertButton
                    ? prev
                    : next
            )
        }
        sync()
        return store.subscribe(sync)
    }, [ivPlotTimeBucket])

    return runtime
}
